import './index.css'
import React, { useEffect, useRef, useState } from 'react';
import { MagnifyIcon } from '../common/Icons';
import FlashcardPriority from './FlashcardPriority';
import { useProject } from '../../context/ProjectContext';
import { getSLAIndicators } from '../../services/ticket.service';
import { APIResponseModel } from '../../models/api-call';
import ClosedTicketAmountChartWidget from '../OperationReports/reportWidgets/ClosedTicketAmountChart';
import { ClosedTicketReportFilters } from '../../models/reports';
import { DaysRange, getLastNDaysRange } from '../BasicCalendar/Utils';
import ResolutionTimeChartWidget from '../OperationReports/reportWidgets/ResolutionTimeChart';
import { useNavigate } from 'react-router-dom';
import { TicketsFilterFormModel } from '../../models/ticket.model';
import { useTicketsFilterContext } from '../../context/TicketsFilterContext';
import { TICKET_STATUS_ALL, TICKET_STATUS_OPEN } from '../../assets/appConstants/constants';
import { useNotification } from '../../context/NotificationContext';

interface DashboardProps {
  setBlockScreen: (p: boolean) => void
}

const Dashboard: React.FC<DashboardProps> = ({
  setBlockScreen = () => { }
}) => {

  const navigate = useNavigate()
  const { showNotification } = useNotification();

  const { selectedProject } = useProject()
  const [SLAValues, setSLAVAlues] = useState<[{ code: string, name: string, nu_tkts: [], pr_count: number }] | []>([])
  const [loadingSLA, setLoadingSLA] = useState<boolean>(false)
  const [reloadCharts, setReloadCharts] = useState<boolean>(false)
  const one_minute = 60000

  const last7days: DaysRange = getLastNDaysRange(7)

  const defaultFilterCharts: ClosedTicketReportFilters = {
    from: last7days.range.from,
    to: last7days.range.to,
    company: { id: '', label: '' },
    areas: [],
    priority: { id: '', label: '' },
  }

  const { defaultTicketsFilter, setTicketsFilter } = useTicketsFilterContext()
  const [searchTicketNumber, setSearchTicketNumber] = useState<string>('')

  const initComponent = () => {
    setBlockScreen(true)
    setTimeout(() => setBlockScreen(false), 800)
  }

  useEffect(initComponent, [])

  useEffect(() => setReloadCharts(!reloadCharts), [selectedProject])

  const loadSLAIndicators = () => {
    setLoadingSLA(true)
    Promise.all([getSLAIndicators(selectedProject)])
      .then(function (results: APIResponseModel[]) {
        setSLAVAlues(results[0].data)
        setTimeout(() => setLoadingSLA(false), 700)
      }).catch((error) => {
        showNotification(error.response.data.message, 'error')
      }
      )
  }

  useEffect(loadSLAIndicators, [selectedProject])

  useEffect(() => {
    const intervalId = setInterval(() => {
      loadSLAIndicators()
    }, one_minute);

    return () => clearInterval(intervalId);

  }, [selectedProject]);

  const filterTicketsNavigate = (filters: Partial<TicketsFilterFormModel>) => {
    const filterTickets = { ...defaultTicketsFilter, ...filters };
    setTicketsFilter(filterTickets)
    navigate('/tickets/listing')
  }

  const handleSubmitTicketSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!searchTicketNumber.trim()) return
    const filterTickets = {
      ...defaultTicketsFilter,
      number: searchTicketNumber,
      status: TICKET_STATUS_ALL
    };
    setTicketsFilter(filterTickets)
    navigate('/tickets/listing')
  }

  return (<React.Fragment>
    <main className='dashboard-main'>
      <section className='dashboard-searchbox'>
        <form onSubmit={handleSubmitTicketSearch}>
          <input
            type='text'
            id='search'
            placeholder='Número de Ticket . . .'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchTicketNumber(e.target.value)
            }
          />
          <div className='dashboard-input-search-icon'>
            <button type='submit' aria-label='Buscar'>
              <MagnifyIcon />
            </button>
          </div>
        </form>
      </section>

      <section className='dashboard-flashcards'>
        {SLAValues.map((item, index) =>
          <FlashcardPriority
            key={index}
            name={item.name}
            prCode={item.code}
            counter={item.pr_count}
            counterNeedUpdate={item.nu_tkts.length}
            onClick={() => filterTicketsNavigate({
              priority: { id: item.code, label: item.name }
            })}
            onClickNeedUpdate={() => filterTicketsNavigate({
              priority: { id: item.code, label: item.name },
              number: item.nu_tkts,
              needupd: 'Si'
            })}
            loading={loadingSLA}
          />
        )}
      </section>

      <section className='dashboard-charts'>
        <div className='dashboard-chart'>
          <ClosedTicketAmountChartWidget
            title='Tickets Cerrados por Día'
            filters={defaultFilterCharts}
            reload={reloadCharts}

          />
        </div>

        <div className='dashboard-chart'>
          <ResolutionTimeChartWidget
            title='Tiempo de Resolución Promedio'
            filters={defaultFilterCharts}
            reload={reloadCharts}
          />
        </div>

      </section>
    </main>

  </React.Fragment>)
}

export default Dashboard;